// The small label above a section heading. Ink muted, never turquoise and never
// the action blue: an eyebrow is not a link and colour here would make it look
// like one. Uppercase with wide tracking is the one place we shout.
//
// `on="navy"` takes the navy muted ink. It is a prop rather than a className
// override because two colour utilities on one element resolve by stylesheet
// order, not class order, so `text-white/60` beside `text-ink-muted` was a coin
// toss.

export default function Eyebrow({ on = 'light', className = '', children }) {
  const ink = on === 'navy' ? 'text-navy-muted' : 'text-ink-muted'
  return (
    <p className={`text-[13px] font-semibold uppercase tracking-[0.12em] ${ink} ${className}`}>
      {children}
    </p>
  )
}
